import React, { useEffect } from "react";
import { Grid } from "@material-ui/core";
import * as Constants from "../../../../../consts/Constants.js";
import CircularProgress from '@mui/material/CircularProgress';
import { useRouteMatch, withRouter } from "react-router-dom";

import CallDetails from './call-details';
import CallStatus from './call-status';
import CallResults from './call-results';
import Style from "../../../../../styles/js/StyleCallList.js";

import alerter from "../../../../alerts/alerter"
import service from '../../../../../plas/services/calls/service';

function Call({history, callId}) {

  let { url } = useRouteMatch();

  const style = Style();

  const [call, setCall] = React.useState(null);
  const [loading, setLoading] = React.useState(true);
  const [disabled, setDisabled] = React.useState(false);

  const openApplications = (event) => {
    history.push(`${url}/applications`);
  }

  const getCall = () => {
    setLoading(true);
    service.api.calls.get(callId,(response) => {
      if (response.result != null) {
        setCall(response.result);
      } else {
        alerter.showError(response.error);
      }
      setLoading(false);
    });
  }

  useEffect(() => {
    getCall();
  }, []);

  return (

     <div className={style.box} >
      { loading ?
        (
          <div style={{color:Constants.COLOR_PRIMARY}}>
            <CircularProgress color="inherit" />
          </div>
        ) : (
          <div className={style.box} >
            { call != null ? (
            <Grid container spacing={2} style={{height:"100%"}}>
             <Grid item xs={12} lg={6} >
                <Grid item xs={12}>
                  <CallDetails call={call} disabled={disabled} disable={setDisabled} />
                </Grid>
              </Grid>
              <Grid item xs={12} lg={6}>
                <Grid item xs={12}>
                  <CallStatus openApplications={openApplications} call={call} disabled={disabled} disable={setDisabled}/>                  
                </Grid>
                { call.canLoadResults() ? 
                  (<Grid item  xs={12}>
                    <CallResults call={call} disabled={disabled} disable={setDisabled}/>
                  </Grid>) : (null)
                }
              </Grid>
            </Grid>) : (null)}
          </div>
        )
      }
    </div>

   
  );

}

export default withRouter(Call);

